<template>
  <div class="teams">
    <RouterView class="view" />
  </div>
</template>

<script>
export default {

  name: 'Teams',
  data() {
    return {};
  },
};
</script>

<style lang="scss" scoped>
.teams{
  display: flex;
  flex-direction: column;
  padding-bottom: 60px;
  .content-wrapper{
    flex-grow: 10;
    display: flex;
    flex-direction: column;
  }
}
</style>
